import { AreaI } from "interfaces/Area";
import { TituloI } from "../interfaces/Titulo";
import { NivelI } from "interfaces/Nivel";

export interface infoFetchGetAreaI {
  id: number | string;
  nombre: string;
  descripcion: string;
  nivel: NivelI;
}

class Area implements AreaI {
  id: number | string;
  nombre: string;
  descripcion: string;
  nivel: NivelI;

  constructor(dto: infoFetchGetAreaI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.descripcion = dto.descripcion;
    this.nivel = dto.nivel;
  }
}

export const makeArea = (infoFetch: infoFetchGetAreaI) => {
  return new Area(infoFetch);
};
